import { utils, VideoData, VideoEventProvider } from '@ad-engine/core';

const logGroup = 'Anyclip';

export class AnyclipTracker {
	private playerEvents = {
		init: 'init',
		WidgetLoad: 'ready',
		adImpression: 'impression',
		adSkipped: 'skipped',
		adFirstQuartile: 'first_quartile',
		adMidpoint: 'midpoint',
		adThirdQuartile: 'third_quartile',
		adComplete: 'completed',
		adClick: 'clicked',
	};

	public registerAnyclipEvents(anyclipWidget: AnyclipWidget) {
		Object.keys(this.playerEvents).map((eventName) => {
			anyclipWidget.subscribe((data) => this.track(eventName, data), eventName);
		});
	}

	trackInit() {
		const eventName = 'init';
		this.track(eventName, VideoEventProvider.getEventData(this.getVideoData(eventName)));
	}

	trackEligible() {
		const eventName = 'eligible';
		this.track(eventName, VideoEventProvider.getEventData(this.getVideoData(eventName)));
	}

	private track(eventName: string, eventData) {
		const dataForDataWarehouse = VideoEventProvider.getEventData(this.getVideoData(eventName));

		utils.logger(
			logGroup,
			`Anyclip ${eventName} event data: `,
			eventData,
			this.getVideoData(eventName),
			dataForDataWarehouse,
		);

		VideoEventProvider.emit(dataForDataWarehouse);
		VideoEventProvider.emitVideoEvent(dataForDataWarehouse);
	}

	private getVideoData(eventName: string): VideoData {
		return {
			ad_error_code: 0,
			event_name: this.playerEvents[eventName] ?? eventName,
			player: 'anyclip',
			ad_product: 'outstream',
			position: 'incontent_player',
			line_item_id: 'unknown',
			creative_id: 'unknown',
		};
	}
}
